
/**
 * 语言枚举列表
 */
export enum LanguageEnum {
  AR_EG = 'ar-EG',
  AR_MA = 'ar-MA',
  AR_SA = 'ar-SA',
  CS_CZ = 'cs-CZ',
  DE_DE = 'de-DE',
  DZ_BT = 'dz-BT',
  EN_US = 'en-US',
  ES_LA = 'es-419',
  ES_ES = 'es-ES',
  FR_FR = 'fr-FR',
  FR_MA = 'fr-MA',
  ID_ID = 'id-ID',
  IT_IT = 'it-IT',
  JA_JP = 'ja-JP',
  KM_KH = 'km-KH',
  KO_KR = 'ko-KR',
  MS_MY = 'ms-MY',
  MY_MM = 'my-MM',
  NL_NL = 'nl-NL',
  PL_PL = 'pl-PL',
  PT_PT = 'pt-PT',
  RO_RO = 'ro-RO',
  RU_RU = 'ru-RU',
  TH_TH = 'th-TH',
  TL_PH = 'tl-PH',
  TR_TR = 'tr-TR',
  UR_PK = 'ur-PK',
  VI_VN = 'vi-VN',
  ZH_CN = 'zh-CN',
  ZH_HK = 'zh-HK',
  ZH_TW = 'zh-TW',
}

export enum ECookieKey {
  language = 'ChannelLanguage',
}

export const getLanguageList = () => [
  { title: '简体中文', id: LanguageEnum.ZH_CN, local: 'CN' },
  { title: 'English', id: LanguageEnum.EN_US, local: 'US' },
  { title: 'Bahasa Indonesia', id: LanguageEnum.ID_ID, local: 'ID' },
  { title: '中文(繁體)', id: LanguageEnum.ZH_TW, local: 'TW' },
  { title: '阿拉伯语', id: LanguageEnum.AR_EG, local: 'EG' },
  { title: '阿拉伯语(马来西亚)', id: LanguageEnum.AR_MA, local: 'MA' },
  { title: '阿拉伯语(沙特阿拉伯)', id: LanguageEnum.AR_SA, local: 'SA' },
  { title: '捷克语', id: LanguageEnum.CS_CZ, local: 'CZ' },
  { title: '德语', id: LanguageEnum.DE_DE, local: 'DE' },
  { title: '阿拉伯语(不丹)', id: LanguageEnum.DZ_BT, local: 'BT' },
  { title: '英语', id: LanguageEnum.EN_US, local: 'US' },
  { title: '西班牙语(拉丁美洲)', id: LanguageEnum.ES_LA, local: '419' },
  { title: '西班牙语(西班牙)', id: LanguageEnum.ES_ES, local: 'ES' },
  { title: '法语', id: LanguageEnum.FR_FR, local: 'FR' },
  { title: '法语(摩洛哥)', id: LanguageEnum.FR_MA, local: 'MA' },
  { title: '印尼语', id: LanguageEnum.ID_ID, local: 'ID' },
  { title: '意大利语', id: LanguageEnum.IT_IT, local: 'IT' },
  { title: '日语', id: LanguageEnum.JA_JP, local: 'JP' },
  { title: '柬埔寨语', id: LanguageEnum.KM_KH, local: 'KH' },
  { title: '韩语', id: LanguageEnum.KO_KR, local: 'KR' },
  { title: '马来语', id: LanguageEnum.MS_MY, local: 'MY' },
  { title: '缅甸语', id: LanguageEnum.MY_MM, local: 'MM' },
  { title: '荷兰语', id: LanguageEnum.NL_NL, local: 'NL' },
  { title: '波兰语', id: LanguageEnum.PL_PL, local: 'PL' },
  { title: '葡萄牙语(葡萄牙)', id: LanguageEnum.PT_PT, local: 'PT' },
  { title: '罗马尼亚语', id: LanguageEnum.RO_RO, local: 'RO' },
  { title: '俄语', id: LanguageEnum.RU_RU, local: 'RU' },
  { title: '泰语', id: LanguageEnum.TH_TH, local: 'TH' },
  { title: '菲律宾语', id: LanguageEnum.TL_PH, local: 'PH' },
  { title: '土耳其语', id: LanguageEnum.TR_TR, local: 'TR' },
  { title: '乌尔都语', id: LanguageEnum.UR_PK, local: 'PK' },
  { title: '越南语', id: LanguageEnum.VI_VN, local: 'VN' },
  { title: '中文(简体)', id: LanguageEnum.ZH_CN, local: 'CN' },
  { title: '中文(繁体)', id: LanguageEnum.ZH_HK, local: 'HK' },
  { title: '中文(繁体)', id: LanguageEnum.ZH_TW, local: 'TW' },
]

/**
 * 根据地区代码获取对应的语言枚举
 */
const getLanguageByLocale = (locale: string): LanguageEnum => {
  if (!locale) {
    return LanguageEnum.EN_US
  }

  const lowerLocale = locale.toLowerCase()

  // 获取所有支持的语言列表
  const supportedLanguages = getLanguageList()

  // 尝试匹配完整的语言代码（如 'zh-cn'）
  const fullMatch = supportedLanguages.find((lang) => lang.id.toLowerCase() === lowerLocale)
  if (fullMatch) {
    return fullMatch.id
  }

  // 尝试匹配国家/地区代码（如 'CN'）
  const localMatch = supportedLanguages.find((lang) => lang.local.toLowerCase() === lowerLocale)
  if (localMatch) {
    return localMatch.id
  }

  // 默认返回英语
  return LanguageEnum.EN_US
}

/**
 * 默认国际化语言
 */
export const language = (() => {

  // 获取app 链接带参传入的语言 参数名language
  const local = new URLSearchParams(window.location.search).get('language')
  if (local) {
    return getLanguageByLocale(local) as LanguageEnum
  }

  // 获取浏览器区域设置
  const locale = navigator.language
  const hasLanguage = getLanguageList().find((item) => item.id === locale)

  // 如果能找到对应的语言设置，则使用该设置
  if (hasLanguage) {
    return hasLanguage.id
  }

  // 默认使用英语
  return LanguageEnum.EN_US
})() as LanguageEnum
